// src/pages/Invoices/Report/ItemsProfitSummary.jsx
import React from 'react';
import ProfitReportPage, { ITEMS_PROFIT_SUMMARY } from './ProfitReportPage';

export default function ItemsProfitSummary() {
  return <ProfitReportPage config={ITEMS_PROFIT_SUMMARY} />;
}
